import adminRequest from '../../../../../../utils/adminRequest'

export const crawlInstituteUrl = async (url) => {
  try {
    const response = await adminRequest.post(
      '/web-crawler/crawl',
      { url }
    )

    console.log('Backend Crawler Response:', response.data)

    if (!response.data?.data) {
      throw new Error('No data received from backend crawler')
    }

    return transformBackendResponse(response.data.data)
  } catch (error) {
    console.error('Crawl error:', error)
    throw new Error(error.response?.data?.message || error.message || 'Failed to fetch website data')
  }
}

function transformBackendResponse(data) {
  return {
    url: data.url || null,
    name: data.name || null,
    email: data.email || null,
    secondaryEmail: data.secondaryEmail || null,
    phone: data.phone || [],
    address: data.address || null,
    addressCity: data.addressCity || null,
    addressState: data.addressState || null,
    addressPincode: data.addressPincode || null,
    addressCampus: data.addressCampus || null,
    university: data.university || null,
    contactPersonName: data.contactPersonName || null,
    contactPersonRole: data.contactPersonRole || null,
    courses: data.courses || [],
  }
}

export const searchCollegeInDatabase = async (collegeName, city, state) => {
  try {
    const response = await adminRequest.post(
      '/web-crawler/search-college',
      { collegeName, city: city || '', state: state || '' }
    )

    return response.data?.data?.matches || []
  } catch (error) {
    console.error('College search error:', error)
    throw new Error(error.response?.data?.message || error.message || 'Failed to search college')
  }
}

export const fetchCollegeCourses = async match => {
  try {
    const response = await adminRequest.post(
      '/web-crawler/college-courses',
      {
        url: match.url,
        title: match.title || '',
        city: match.city || '',
        state: match.state || '',
      }
    )

    if (!response.data?.data) {
      throw new Error('No course data found for this college')
    }

    return transformBackendResponse(response.data.data)
  } catch (error) {
    console.error('College courses error:', error)
    throw new Error(error.response?.data?.message || error.message || 'Failed to fetch college courses')
  }
}
